import { Box, Stack, Text } from '@amboss/design-system';

declare type EmptyPlaceholderProps = {
  header: string;
  subHeader?: string | null;
};

const EmptyPlaceholder = ({ header, subHeader = '' }: EmptyPlaceholderProps) => {
  return (
    <Box>
      <Stack space={'m'}>
        <Text align='center' weight='bold'>
          {header}
        </Text>
        <Text align='center' color={'tertiary'}>
          {subHeader}
        </Text>
      </Stack>
    </Box>
  );
};

export default EmptyPlaceholder;
